import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useCallback, KeyboardEvent as ReactKeyboardEvent } from 'react';

type UnderwritingNavigationConfirmModalProps = {
  isOpen: boolean;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
  onReject: () => void;
};

export const UnderwritingNavigationConfirmModal: React.FC<UnderwritingNavigationConfirmModalProps> = ({
  isOpen,
  onSubmit,
  onCancel,
  onReject,
}) => {
  const onKeyDown = useCallback(
    async (event: ReactKeyboardEvent) => {
      if (event.key === 'Enter' && event.currentTarget.localName !== 'form-confirm-reject-btn') {
        onSubmit();
      }
    },
    [onSubmit]
  );

  return (
    <Dialog open={isOpen} onKeyDown={onKeyDown} onClose={onCancel}>
      <DialogTitle>
        <Typography variant="h6" component="span">
          You have unsaved changes.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Would you like to save changes before continuing?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onReject} variant="text" name="form-confirm-reject-btn">
          No
        </Button>
        <Button onClick={onSubmit} variant="contained">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
